import { loadCashDrawerConfiguration } from "./cash-drawer";
import { printPdfDirectlyToEpson } from "./epson-ticket";

function browserPdf(bytes: Uint8Array, filename: string, download: boolean): void {
  const blob = new Blob([new Uint8Array(bytes)], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  if (download) {
    anchor.download = filename;
    anchor.click();
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function downloadPdf(bytes: Uint8Array, filename: string): void {
  browserPdf(bytes, filename, true);
}

export async function printReceiptPdf(bytes: Uint8Array, filename: string): Promise<"LOCAL" | "BROWSER"> {
  try {
    await printPdfDirectlyToEpson(bytes, loadCashDrawerConfiguration());
    return "LOCAL";
  } catch {
    browserPdf(bytes, filename, false);
    return "BROWSER";
  }
}
